export default __webpack_public_path__ + "static/media/type_17_5.513bcdf1.svg";